import { gql } from '@apollo/client';

export const ADD_PRODUCTS_TO_CREATE_CART = gql`
  mutation addProductsToUpgradeCart(
    $hp_subscription_id: String!
    $printer_sku: String!
    $selected_printer_uid: ID!
    $selected_ink_plan_uid: ID!
    $selected_lease_plan_uid: ID!
    $selected_carepack_uid: ID!
    $selected_paper_plan_uid: ID
  ) {
    addProductsToUpgradeCart(
      hp_subscription_id: $hp_subscription_id
      cartItems: [
        {
          quantity: 1
          sku: $printer_sku
          selected_options: [
            $selected_printer_uid
            $selected_ink_plan_uid
            $selected_lease_plan_uid
            $selected_carepack_uid
            $selected_paper_plan_uid
          ]
        }
      ]
    ) {
      cart {
        id
        items {
          uid
          product {
            name
            sku
          }
          prices {
            row_total_including_tax {
              value
              currency
            }
            row_total {
              value
              currency
            }
          }
          quantity
        }
      }
      user_errors {
        code
        message
      }
    }
  }
`;
